import { api } from '../../../utils/client';
import type { CreditPricingTierRow } from './types';

function asList<T>(data: T[] | { results?: T[] }): T[] {
  return Array.isArray(data) ? data : data?.results ?? [];
}

export async function fetchAdminCreditPricingTiers() {
  const data = await api<CreditPricingTierRow[] | { results: CreditPricingTierRow[] }>(
    '/api/admin/credit-pricing-tiers/'
  );
  return asList(data);
}

export async function patchAdminCreditPricingBase(
  currencyCode: string,
  costPerCredit: string,
) {
  const data = await api<CreditPricingTierRow[] | { results: CreditPricingTierRow[] }>(
    '/api/admin/credit-pricing-tiers/',
    {
      method: 'PATCH',
      body: JSON.stringify({
        currency_code: currencyCode,
        cost_per_credit: costPerCredit,
      }),
    },
  );
  return asList(data);
}
